import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Compose des classes : les utilités Tailwind en conflit se résolvent (la dernière gagne), les
 * classes du kit (`bouton`, `ligne`…) passent telles quelles.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
